import React from 'react';
import cn from 'classnames';
import { Avatar, AvatarFallback, AvatarImage } from '@frontend/shadcn/components/ui/avatar';
import { getColorFromName, getInitials } from '@frontend/app/refresh-components/NameCell';
import { VerifiedBadgeIcon } from '../../../../components/icons/verified-badge-icon';

interface SocialMemberProps extends React.HTMLAttributes<HTMLAnchorElement> {
  image?: string;
  name: string;
  handle: string;
  isVerified?: boolean;
}

const SocialMember: React.FC<SocialMemberProps> = ({
  name,
  image,
  handle,
  isVerified = false,
  className,
  ...props
}) => (
  <a
    href={`https://instagram.com/${handle}`}
    target="_blank"
    rel="noopener noreferrer"
    className={cn('flex gap-1 items-center px-2 text-primary hover:text-primary', className)}
    onClick={(e) => e.stopPropagation()}
    {...props}
  >
    <Avatar className="w-6 h-6">
      <AvatarImage src={image || '/default-avatar.png'} alt={name} />
      <AvatarFallback
        className={cn(
          'flex items-center justify-center h-full w-full text-white font-semibold text-[10px]',
          getColorFromName(name),
        )}
      >
        {getInitials(name)}
      </AvatarFallback>
    </Avatar>
    <span className="overflow-hidden text-ellipsis whitespace-nowrap hover:underline">{name}</span>
    {isVerified && (
      <VerifiedBadgeIcon className="w-4 h-4" />
    )}
  </a>
);

export default SocialMember;
